import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';
import IconClose from '../../../icons/close.svg';

import styles from './ModalDialog.scss';

ModalDialog.propTypes = {
    closeButton: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    children: PropTypes.node,
    className: PropTypes.string,
    onClose: PropTypes.func,
    modal: PropTypes.object,
    isOpen: PropTypes.bool,
};

ModalDialog.defaultProps = {
    closeButton: true,
    isOpen: false,
};

export default function ModalDialog({ isOpen, className, onClose, children, title, closeButton, modal }) {
    if (!isOpen) return null;

    return (
        <Modal {...modal} onClose={onClose} className={styles.container}>
            <div className={classNames(styles.root, className)}>
                {closeButton && (
                    <div className={styles.iconBtn} onClick={onClose}>
                        <IconClose className={styles.icon} />
                    </div>
                )}
                {title && (
                    <div className={styles.header}>
                        <div className={styles.title}>{typeof title !== 'function' ? title : title()}</div>
                    </div>
                )}
                <div className={styles.content}>{children}</div>
            </div>
        </Modal>
    );
}
